export default function initData(header, data, buttons, sort, timeline, prefix, selected = []) {
	return (dispatch) => {
		dispatch({
			type: 'INIT_LIST',
			payload: {header, data, buttons, sort, timeline, prefix, selected},
		});
	};
}